import { ICellRendererParams } from "ag-grid-community";

export const booleanValueRenderer = (params: ICellRendererParams) => (
  <span
    className={`ag-icon ag-icon-${
      params.value ? "tick" : "cross"
    } content-icon`}
  />
);
